import { forwardRef } from 'react'
import { LinkCore, LinkProps } from 'solito/link'
import { styled, SizableText, SizableTextProps } from 'tamagui'

const StyledTextLink = styled(SizableText, {
  name: 'TextLink',
})

export type TextLinkProps = Pick<LinkProps, 'href' | 'target'> &
  SizableTextProps

export const TextLink = forwardRef<HTMLAnchorElement, TextLinkProps>(
  ({ children, href, target, ...restProps }, ref) => {
    return (
      <LinkCore
        Component={StyledTextLink}
        componentProps={{
          tag: 'a',
          hoverStyle: { color: '$brandPink' },
          pressStyle: { color: '$brandPink_op80' },
          focusStyle: { color: '$brandPink_op80' },
          ...restProps,
        }}
        href={href}
        ref={ref}
        target={target}
      >
        {children}
      </LinkCore>
    )
  },
)
